import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { createMapUrl } from '@app/utils';
import _ from 'lodash';

@Component({
  selector: 'app-landing-popular-waterways',
  templateUrl: './popular-waterways.component.html',
  styleUrls: ['./popular-waterways.component.scss'],
})
export class PopularWaterwaysComponent implements OnInit {
  @Input() waterways: any;
  @Input() name: string;

  constructor(private router: Router) {}

  ngOnInit() {}

  truncate(str) {
    return _.truncate(str, { length: 220, separator: ' ' });
  }

  navigateWaterway(waterway: any) {
    this.router.navigate([waterway.waterwayUrl]);
  }
}
